package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
data class AdminRequest<T>(
    override val email: String,
    override val role: UserRole,
    override val request: T? = null,
): AuthenticatedEnvelope<T>

@Serializable
data class AdminMainDashRequest(
    val email: String
)

@Serializable
data class BuyCreditRequest(
    val email: String,
    val amount: Int
)

@Serializable
data class AdminCreditsDashRequest(
    val email: String
)

@Serializable
data class AdminStudentsDashRequest(
    val email: String,
)

@Serializable
data class AdminInviteRequest(
    val inviter: String,
    val invitee: String
)

@Serializable
data class AdminAssignCreditRequest(
    val email: String,
    val studentId: String
)

@Serializable
data class AdminStudentsListRequest(
    val email: String,
)

@Serializable
data class OrgUserTestDataRequest(
    val email: String,
    val testId: String
)

@Serializable
data class AdminDataStatsPayload(
    val totalStud: Int,
    val totalTestSub: Int,
    val totalNeedVerify: Int,
    val creditStats: AdminCreditStatistics
)

@Serializable
data class AdminCreditsDashPayload(
    val transactions: List<CreditTransaction>,
    val creditStats: AdminCreditStatistics
)

@Serializable
enum class PaymentStatus { PENDING, PAID, FAILED }

@Serializable
data class CreditInfo(
    val id: String,
    val status: CreditStatus,
)

@Serializable
data class CreditTransaction(
    val id: String,
    val purchasedAmount: Int,
    val status: PaymentStatus,
    val purchaseAt: Instant,
    val toyyibpayId: String,
    val amountPaidCents: Int,
    val creditsPurchased: List<CreditInfo>
)

@Serializable
data class AdminCreditStatistics (
    val total: Int? = null,
    val used: Int? = null,
    val active: Int? = null,
    val expired: Int? = null,
    val assigned: Int? = null
)

@Serializable
enum class InviteStatus { INVITED, ACCEPTED, EXPIRED }

@Serializable
data class StudentInvite(
    val name: String?,
    val email: String,
    val invitedAt : Instant,
    val status: InviteStatus,
)

@Serializable
data class AdminStudentsInvitePayload(
    val invites: List<StudentInvite>
)

@Serializable
enum class StudentStatus {
    UNASSIGNED, ASSIGNED, IN_PROGRESS, PENDING, REJECTED, VERIFIED
}

@Serializable
data class Student(
    val id: String,
    val name: String,
    val email: String,
    val nric: String,
    val address: String,
    val phone: String,
    val workType: String,
    val status: StudentStatus
)

@Serializable
data class AdminStudentsInfoPayload(
    val students: List<Student>
)